import type { Permission } from '@/core/api/policy'

type Translate = (key: string) => string

export const ACTION_LABEL_KEY: Record<string, string> = {
  manage: 'authz.action.manage',
  create: 'authz.action.create',
  read: 'authz.action.read',
  list: 'authz.action.list',
  update: 'authz.action.update',
  delete: 'authz.action.delete',
}

export const RESOURCE_LABEL_KEY: Record<string, string> = {
  Patient: 'authz.resource.Patient',
  Consultation: 'authz.resource.Consultation',
  Staff: 'authz.resource.Staff',
  Expertise: 'authz.resource.Expertise',
  MeetingLink: 'authz.resource.MeetingLink',
  CustomDevice: 'authz.resource.CustomDevice',
  Etablissement: 'authz.resource.Etablissement',
  Establishment: 'authz.resource.Etablissement',
  Statistics: 'authz.resource.Statistics',
  FormTemplate: 'authz.resource.FormTemplate',
  FormSubmission: 'authz.resource.FormSubmission',
  InsTeleservice: 'authz.resource.InsTeleservice',
  Admin: 'authz.resource.Admin',
  Desmos: 'authz.resource.Desmos',
}

export function translateAction(action: string, t: Translate): string {
  const key = ACTION_LABEL_KEY[action]
  return key ? t(key) : action
}

export function translateResource(resource: string, t: Translate): string {
  const key = RESOURCE_LABEL_KEY[resource]
  return key ? t(key) : resource
}

export type DroitAction = {
  key: string
  label: string
}

export type Droit = {
  resource: string
  actions: DroitAction[]
}

export function formatDroits(permissions: Permission[], t: Translate): Droit[] {
  const byResource = new Map<string, Set<string>>()
  for (const permission of permissions) {
    for (const resource of permission.resource) {
      const actions = byResource.get(resource) ?? new Set<string>()
      for (const action of permission.action) {
        actions.add(action)
      }
      byResource.set(resource, actions)
    }
  }
  return Array.from(byResource.entries()).map(([resource, actions]) => ({
    resource: translateResource(resource, t),
    actions: Array.from(actions).map((action) => ({ key: action, label: translateAction(action, t) })),
  }))
}
